import Model from './Model';

export default class AffiliateLink extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'affiliate-links';
  }
}
